import { HIDE_ASIDE_MENU, TOGGLE_ASIDE_MENU } from "../../actionTypes";

export const toggleAsideMenu = () => {
	return {
		type: TOGGLE_ASIDE_MENU,
	};
};

export const hideAsideMenu = () => {
	return {
		type: HIDE_ASIDE_MENU,
	};
};
